import { useEffect, useState } from 'react';
import { Form, InputGroup, Button, Badge, Spinner } from 'react-bootstrap';
import { CopyIcon, CheckIcon } from './icons';
import BsaleWebhookClient from '../services/bsalewebhookclient';

const COOKIE_STORAGE_KEY = 'bsale_account_cookie';

function BsaleHook(props) {
  const [copied, setCopied] = useState(false);
  const [cookie, setCookie] = useState(
    () => window.localStorage.getItem(COOKIE_STORAGE_KEY) || ''
  );
  const [email, setEmail] = useState('all@loadingplay.com');
  const [password, setPassword] = useState('');
  const [connecting, setConnecting] = useState(false);
  const [connectError, setConnectError] = useState('');
  const [checkingStatus, setCheckingStatus] = useState(false);
  const [registered, setRegistered] = useState(null);
  const [registering, setRegistering] = useState(false);

  const webhook_url = `${process.env.REACT_APP_API_URL}/bsale/hook/listener/${props.site_name}`;
  const client = new BsaleWebhookClient(props.lp_access_token);

  const checkStatus = async () => {
    if (!cookie || !props.access_token_bsale) return;

    setCheckingStatus(true);
    const result = await client.status(
      props.access_token_bsale, cookie, webhook_url
    );
    setRegistered(!!result.registered);
    setCheckingStatus(false);
  };

  useEffect(() => {
    checkStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookie, props.access_token_bsale]);

  const onCopy = async () => {
    await navigator.clipboard.writeText(webhook_url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const onConnect = async () => {
    setConnecting(true);
    setConnectError('');
    const result = await client.login(email, password);

    if (result.status === 'ok') {
      window.localStorage.setItem(COOKIE_STORAGE_KEY, result.cookie);
      setCookie(result.cookie);
      setPassword('');
    } else {
      setConnectError(result.message || 'No se pudo conectar a BSale');
    }
    setConnecting(false);
  };

  const onDisconnect = () => {
    window.localStorage.removeItem(COOKIE_STORAGE_KEY);
    setCookie('');
    setRegistered(null);
  };

  const onRegister = async () => {
    setRegistering(true);
    const result = await client.register(
      props.access_token_bsale, cookie, webhook_url
    );

    if (result.status === 'ok') {
      await checkStatus();
    } else {
      alert(result.message || 'No se pudo registrar el webhook');
    }
    setRegistering(false);
  };

  return (
    <>
      <InputGroup>
        <Form.Control
          onFocus={(e) => e.target.select()}
          readOnly={true}
          type="text"
          value={webhook_url}
        />
        <Button variant="outline-secondary" className="copy-button" type="button" onClick={onCopy}>
          {copied ? <CheckIcon /> : <CopyIcon />}
          {copied ? 'Copiado' : 'Copiar'}
        </Button>
      </InputGroup>

      <div className="bsale-webhook-status mt-2">
        {!cookie ? (
          <div className="d-flex flex-column gap-2">
            <Form.Text className="text-muted">
              Conéctate con tu cuenta de BSale para poder registrar este
              webhook directo desde acá.
            </Form.Text>
            <Form.Control
              size="sm"
              type="email"
              placeholder="Email BSale"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Form.Control
              size="sm"
              type="password"
              placeholder="Password BSale"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {connectError && (
              <Form.Text className="text-danger">{connectError}</Form.Text>
            )}
            <Button
              size="sm"
              variant="outline-primary"
              type="button"
              disabled={connecting || !email || !password}
              onClick={onConnect}
            >
              {connecting ? 'Conectando...' : 'Conectar cuenta BSale'}
            </Button>
          </div>
        ) : (
          <div className="d-flex align-items-center gap-2 flex-wrap">
            {checkingStatus ? (
              <Spinner animation="border" size="sm" />
            ) : registered ? (
              <Badge bg="success" pill>Webhook registrado</Badge>
            ) : (
              <Badge bg="secondary" pill>No registrado</Badge>
            )}
            {!checkingStatus && !registered && (
              <Button
                size="sm"
                variant="warning"
                type="button"
                disabled={registering || !props.access_token_bsale}
                onClick={onRegister}
              >
                {registering ? 'Registrando...' : 'Registrar webhook'}
              </Button>
            )}
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-muted"
              onClick={onDisconnect}
            >
              Desconectar cuenta BSale
            </Button>
          </div>
        )}
      </div>

      <Form.Text className="text-muted">
        <b>cpn id: </b> {props.company.id}<br/>
        <b>empresa: </b>{props.company.name}<br/>
        <b>rut: </b> {props.company.code}<br/>
        <b>país: </b> {props.company.country}<br/>
      </Form.Text>
    </>
  );
}

export default BsaleHook;
